export enum NotesSaveState {
  SAVING = "SAVING",
  SAVED = "SAVED",
  FAILED = "FAILED",
}
